<template>
  <div>
    <div class="d-flex justify-space-between align-center pa-4 pa-md-2">
      <Breadcrumbs
        headline="Thu nợ"
        :link="[{ text: 'Thu nợ', href: '../liability' }]"
      />
    </div>
    <v-row class="pa-0 ma-0">
      <v-col :md="8" class="py-0">
        <v-card elevation="1" >
          <lead-selector
            :lead.sync="lead"
            :student.sync="student"
            class="pa-4"
          ></lead-selector>
        </v-card>
      </v-col>
      <v-col :md="4" class="py-0">
        <v-card class="pa-4">
          <bill :lead="lead" :student="student" ref="form"></bill>
          <div class="text-right py-3">
            <v-btn
              id="send-tution-fee-button"
              color="green light"
              depressed
              dark
              :disabled="!lead"
              @click="save()"
              :loading="loading"
            >
              Nộp Học Phí
            </v-btn>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Bill from '@/components/basic/form/BillTuitionForm .vue'
import LeadSelector from '@/modules/sales/SaleLeadSelector.vue'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
export default {
  components: { Bill, LeadSelector, Breadcrumbs },
  data() {
    return {
      loading: false,
      lead: {},
      student: {},
    }
  },
  created() {},
  mounted() {},
  computed: {
    ...mapGetters('app', ['department']),
    ...mapGetters('auth', ['profile']),
  },
  methods: {
    ...mapActions('sale', ['createBill', 'createLead', 'updateLead']),
    async save() {
      this.loading = true
      const bill = await this.createNewBill()
      await this.updateLeads(bill)
      this.loading = false
    },
    async updateLeads(bill) {
      const bills = [...this.lead.bills, bill]
      const customerPaid = bills.reduce((acc, cur) => acc + cur.customerPaid, 0)
      const liabilities = this.lead.total - customerPaid
      await this.updateLead({
        id: this.lead.id,
        customerPaid,
        liabilities,
        status: liabilities > 0 ? 'liabilities' : 'paid',
        notes: bill.notes,
      })
    },
    async createNewBill() {
      const bill = this.$refs.form.getValues()
      const data = await this.createBill({
        data: {
          ...bill,
          department: this.department.id,
          staff: this.profile.id,
          lead: this.lead.id,
        },
      })
      return data
    },
  },
}
</script>
<style lang="scss" scoped>

</style>
